import { useState } from "react";
import { api, apiError } from "@/lib/api";
import { toast } from "sonner";
import { Banknote, X } from "lucide-react";

const METHODS = [
  { v: "cash", l: "Cash" },
  { v: "upi", l: "UPI" },
  { v: "card", l: "Card" },
  { v: "cheque", l: "Cheque" },
  { v: "bank_transfer", l: "Bank Transfer" },
];

export default function CashCollectButton({ invoiceId, amount, onDone }) {
  const [open, setOpen] = useState(false);
  const [method, setMethod] = useState("cash");
  const [amt, setAmt] = useState(amount ?? "");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/admin/invoices/collect", {
        invoice_id: invoiceId, method,
        amount: amt === "" ? undefined : Number(amt),
        note: note || undefined,
      });
      toast.success(`Collected ₹${data.amount_paid} · ${data.payment_status}`);
      setOpen(false); if (onDone) onDone();
    } catch (e) { toast.error(apiError(e)); }
    finally { setBusy(false); }
  };

  if (!open) {
    return (
      <button onClick={() => setOpen(true)}
        data-testid={`cash-collect-open-${invoiceId}`}
        className="text-[10px] font-mono uppercase tracking-widest border border-brand-blue text-brand-blue px-2 py-1 hover:bg-brand-blue hover:text-black inline-flex items-center gap-1"
      >
        <Banknote size={11} /> Collect Offline
      </button>
    );
  }
  return (
    <div className="border border-brand-blue/40 bg-brand-blue/5 p-3 w-full" data-testid={`cash-collect-form-${invoiceId}`}>
      <div className="flex items-center justify-between mb-2">
        <div className="text-[10px] font-mono uppercase tracking-widest brand-blue">Record offline payment</div>
        <button onClick={() => setOpen(false)} className="text-white/40 hover:text-white"><X size={12} /></button>
      </div>
      <div className="grid grid-cols-2 gap-2 mb-2">
        <select value={method} onChange={(e) => setMethod(e.target.value)}
          data-testid={`cash-collect-method-${invoiceId}`}
          className="bg-black/40 border border-white/15 py-1.5 px-2 text-xs">
          {METHODS.map((m) => <option key={m.v} value={m.v}>{m.l}</option>)}
        </select>
        <input type="number" placeholder="Amount" value={amt}
          data-testid={`cash-collect-amount-${invoiceId}`}
          onChange={(e) => setAmt(e.target.value)}
          className="bg-black/40 border border-white/15 py-1.5 px-2 text-xs" />
      </div>
      <input value={note} onChange={(e) => setNote(e.target.value)}
        placeholder="Note (optional)"
        className="w-full bg-black/40 border border-white/15 py-1.5 px-2 text-xs mb-2" />
      <button onClick={submit} disabled={busy}
        data-testid={`cash-collect-confirm-${invoiceId}`}
        className="w-full bg-brand-blue text-black py-1.5 text-[11px] font-bold uppercase tracking-widest disabled:opacity-50">
        {busy ? "Recording…" : "Record Payment"}
      </button>
    </div>
  );
}
